<script setup lang="ts">
import { IVideo } from '@/interfaces';

interface Props {
  videos: IVideo[];
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits(['video-selected']);
</script>

<template>
  <div class="object-cover">
    <div v-if="!videos.length" class="flex flex-col items-center pt-[200px]">
      <fa-icon
        class="text-neutral-300 text-6xl mb-3"
        :icon="['fas', 'fa-film']"
      />

      <p class="h700">{{ $t('media.noVideos') }}</p>
    </div>

    <div
      class="relative flex items-center justify-center"
      v-for="(video, index) in videos"
      :key="index"
    >
      <fa-icon
        class="text-neutral-0 absolute z-20"
        :icon="['fas', 'fa-caret-right']"
        @click="emit('video-selected', index)"
      />

      <img
        :src="video.thumbnail"
        class="picture relative object-cover w-full rounded-[20px] mb-12"
        @click="emit('video-selected', index)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.picture {
  height: 500px;
}

.fa-caret-right {
  font-size: 120;
}
</style>
